<template>
    <div class="spcialBox text-center">
        <div v-if="loading" class="no_data">...</div>
        <div v-else-if="!imageSrc" class="no_data">{{ $t('table.noData') }}</div>
        <div v-else class="imgBox">
            <img :src="imageSrc" alt="" />
        </div>
    </div>
</template>

<style>
.spcialBox {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.spcialBox .imgBox {
    width: 100%;
}

.spcialBox img {
    object-fit: contain;
    height: 100%;
    width: 100%;
}

.spcialBox .no_data {
    background-color: rgb(80, 80, 80, 0.5);
    padding: 5px 20px;
    border-radius: 0.5em;
    color: black;
}
</style>

<script>
/* eslint-disable */

export default {
    name: 'imgMonitor',
    emits: ['breadcrumb'],
    components: {},
    data() {
        return {
            response: null,
            loading: true,
            pollInterval: null,
        }
    },
    methods: {
        async fetchImage() {
            const data = await this.$axios.get({ uri: '/last_img' })
            if (data && !Array.isArray(data)) {
                this.response = data
            } else if (typeof data === 'string' && data.length > 0) {
                this.response = data
            }
            this.loading = false
        }
    },
    async mounted() {
        this.$emit('breadcrumb', [this.$t('nav.tourMonitor')])
        await this.fetchImage()
        this.pollInterval = setInterval(() => {
            this.fetchImage()
        }, 5 * 1000);
    },
    beforeUnmount() {
        if (this.pollInterval) clearInterval(this.pollInterval)
    },
    computed: {
        imageSrc() {
            if (!this.response) return null
            if (typeof this.response === 'string') {
                return `data:image/png;base64,${this.response}`
            }
            const b64 = this.response.image_base64 || this.response.image
            if (!b64 || typeof b64 !== 'string') return null
            return `data:image/png;base64,${b64}`
        }
    }
}
</script>
